<div class="lottie-animation">
  <ng-lottie [options]="{path}"></ng-lottie>
</div>
